<template>
  <v-app>
    <v-container>
      <v-row style="margin-top:3rem;">
        <v-col cols="0" lg="4"></v-col>
        <v-col lg="4" cols="12">
          <v-form @submit.prevent="iniciarSesion()">
            <v-text-field
            @focus="$event.target.select()"
              autofocus
              v-model="usuarioCredenciales.Usuario"
              label="Usuario"
              required
            ></v-text-field>
            <v-text-field
            @focus="$event.target.select()"
              :append-icon="showPassword1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword1 ? 'text' : 'password'"
              @click:append="showPassword1 = !showPassword1"
              v-model="usuarioCredenciales.Password"
              label="Contraseña"
              required
            ></v-text-field>
            <v-row>
              <v-col cols="6">
                <v-btn class="dbtn" type="submit" color="success">Aceptar</v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn class="dbtn" @click="limpiarLogin()" color="error">Cancelar</v-btn>
              </v-col>
            </v-row>
          </v-form>
          <img
            hidden
            src="../assets/qr_code.png"
            style="height:100px;width:100px;"
            alt="contrato de privacidad"
          />
          <v-btn v-if="1 > 2" @click="modalResetPassword = true" block text color="primary">
            reestablecer contraseña
          </v-btn>
        </v-col>
        <v-col cols="" lg="4"></v-col>
      </v-row>
      <v-dialog v-model="dialog" max-width="290" persistent>
        <v-card>
          <v-card-title class="headline">Aviso</v-card-title>
          <v-card-text>
            {{ msgError.msg }}
          </v-card-text>
          <v-card-actions>
            <v-btn style="width:100%" color="red darken-1" text @click="dialog = false">
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <ResetPassword :show="modalResetPassword" @cierra-reset-password="cierraResetPassword()" />
  </v-app>
</template>

<script>
import axios from "axios";
import ResetPassword from "@/components/ResetPassword.vue";
import { mapActions } from "vuex";

export default {
  name: "Login",
  components: {
    ResetPassword
  },
  data: () => ({
    modalResetPassword: false,
    showPassword1: false,
    msgError: {},
    dialog: false,
    usuarioCredenciales: {
      Usuario: "",
      Password: ""
    }
  }),
  methods: {
    ...mapActions("sesion", ["logIn"]),
    limpiarLogin() {
      this.usuarioCredenciales = { Usuario: "", Password: "" };
    },
    cierraResetPassword() {
      this.modalResetPassword = false;
    },
    async iniciarSesion() {
      const res = await this.logIn(this.usuarioCredenciales);
      if (res[0]) {
        this.$router.push("dashboard");
      } else {
        this.msgError = res[1];
        this.dialog = true;
      }
    }
  }
};
</script>

<style lang="css" scoped>
.dbtn {
  width: 100%;
}
</style>
